/**
 * The message supabase-js `functions-js` sets on a `FunctionsFetchError` — the
 * request never produced an HTTP response (network reset / CORS / cold-start /
 * aborted fetch). Lives in its own dependency-free module so both the transport
 * classifier (`isTransientFetchError` in `supabase-utils.ts`) and the Sentry
 * `beforeSend` backstop (`sentry.ts`) share one source of truth without coupling
 * the startup-path Sentry init to the heavier `supabase-utils` module graph
 * (@supabase/supabase-js, @tanstack/react-query). Change here if the SDK message
 * ever changes — the coupling test in `supabase-utils.test.ts` pins it.
 */
export const FUNCTIONS_FETCH_ERROR_MESSAGE = 'Failed to send a request to the Edge Function';

/**
 * The fetch-failure texts Chrome, Firefox, and WebKit stringify into a
 * PostgREST error's `message` when a `.from()`/`.rpc()` call never produced an
 * HTTP response — the same strings Sentry's default ignore list treats as
 * network noise. A real PostgREST error always carries a server-generated
 * message instead.
 */
export const POSTGREST_TRANSPORT_FAILURE_MESSAGES = [
  'Failed to fetch',
  'NetworkError when attempting to fetch resource',
  'Load failed',
] as const;
